// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eta-disclaimer {
  margin: 24px auto 12px;
  padding: 0 12px;
  font-size: 12px;
  line-height: 1.5;
  color: #9a9a9a;
  text-align: left;
}
/*# sourceMappingURL=Disclaimer.css.map */`, "",{"version":3,"sources":["webpack://./Disclaimer.less","webpack://./src/components/Disclaimer/Disclaimer.less"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;ACCJ;AACA,yCAAyC","sourcesContent":[".eta-disclaimer {\n    margin: 24px auto 12px;\n    padding: 0 12px;\n    font-size: 12px;\n    line-height: 1.5;\n    color: #9a9a9a;\n    text-align: left;\n}\n",".eta-disclaimer {\n  margin: 24px auto 12px;\n  padding: 0 12px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #9a9a9a;\n  text-align: left;\n}\n/*# sourceMappingURL=Disclaimer.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
